exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-head-detail{font-size:16px;font-weight:700;padding:10px 0 5px}.vc-detail{margin:8px 0}.vc-detail .vc-detail__title{color:#6c757d}.vc-detail .vc-detail__value{padding:4px 0 3px;border-bottom:1px solid #dfdfdf}", ""]);

// exports
